import React from "react";
import { PageContainer } from "@catchoftheday/cg-components";
import { Footer, Header } from "@catchoftheday/header";
import { ThemeProvider } from "@catchoftheday/theme";
import { jsx as ___EmotionJSX } from "@emotion/react";

/**
 * Wraps a Next page with required Context providers and common layout components such as Header and Footer.
 */
export var PageLayout = function PageLayout(_ref) {
  var host = _ref.host,
      children = _ref.children;
  return ___EmotionJSX(ThemeProvider, {
    enableGlobalBackgroundConfig: true
  }, ___EmotionJSX(Header, {
    host: host
  }), ___EmotionJSX(PageContainer, null, children), ___EmotionJSX(Footer, null));
};